"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "aprilia": {
    "341d4f02": [{
      "hkey": "2e4b2d0b",
      "slug": "camilleri-vallelata-valli",
      "name": "Camilleri-Vallelata-Valli",
      "primary": true,
      "skipSearch": false
    }],
    "camilleri": [{
      "hkey": "2e4b2d0b",
      "slug": "camilleri-vallelata-valli",
      "name": "Camilleri-Vallelata-Valli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "aprilia"
    }],
    "b802e4ea": [{
      "hkey": "cf6003ce",
      "slug": "campo-di-carne-pantanelle",
      "name": "Campo di Carne-Pantanelle",
      "primary": true,
      "skipSearch": false
    }],
    "campodicarne": [{
      "hkey": "cf6003ce",
      "slug": "campo-di-carne-pantanelle",
      "name": "Campo di Carne-Pantanelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b6a185cf": [{
      "hkey": "3cca47bc",
      "slug": "carano-isole",
      "name": "Carano-Isole",
      "primary": true,
      "skipSearch": false
    }],
    "carano": [{
      "hkey": "3cca47bc",
      "slug": "carano-isole",
      "name": "Carano-Isole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9c73ccde": [{
      "hkey": "b6295586",
      "slug": "casalazzara-sassi-rossi-torre-bruna",
      "name": "Casalazzara-Sassi Rossi-Torre Bruna",
      "primary": true,
      "skipSearch": false
    }],
    "casalazzara": [{
      "hkey": "b6295586",
      "slug": "casalazzara-sassi-rossi-torre-bruna",
      "name": "Casalazzara-Sassi Rossi-Torre Bruna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "12b6c1eb": [{
      "hkey": "ce689f67",
      "slug": "cogna-pontoni",
      "name": "Cogna-Pontoni",
      "primary": true,
      "skipSearch": false
    }],
    "la-gogna": [{
      "hkey": "ce689f67",
      "slug": "cogna-pontoni",
      "name": "Cogna-Pontoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b983a174": [{
      "hkey": "98fb3e7a",
      "slug": "buon-riposo-riserva-nuova",
      "name": "Buon Riposo-Riserva Nuova",
      "primary": true,
      "skipSearch": false
    }],
    "riserva-nuova": [{
      "hkey": "98fb3e7a",
      "slug": "buon-riposo-riserva-nuova",
      "name": "Buon Riposo-Riserva Nuova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0b80cb3e": [{
      "hkey": "cf6003ce",
      "slug": "campo-di-carne-pantanelle",
      "name": "Campo di Carne-Pantanelle",
      "primary": true,
      "skipSearch": false
    }],
    "selciatella-pantanelle-casello45": [{
      "hkey": "cf6003ce",
      "slug": "campo-di-carne-pantanelle",
      "name": "Campo di Carne-Pantanelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "aprilia"
    }],
    "7816c176": [{
      "hkey": "2e4b2d0b",
      "slug": "camilleri-vallelata-valli",
      "name": "Camilleri-Vallelata-Valli",
      "primary": true,
      "skipSearch": false
    }],
    "vallelata": [{
      "hkey": "2e4b2d0b",
      "slug": "camilleri-vallelata-valli",
      "name": "Camilleri-Vallelata-Valli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;